import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgCornerDownLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 3a1 1 0 0 1 1 1v2.51l.001.034.003.111a15.38 15.38 0 0 1-.038 1.46c-.067.875-.235 2.02-.652 3.164-.416 1.146-1.097 2.336-2.216 3.24C16.964 15.437 15.455 16 13.5 16H6.414l3.293 3.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-5-5a.997.997 0 0 1-.173-.232l-.02-.042a.994.994 0 0 1-.073-.664l.016-.062a.995.995 0 0 1 .081-.188c.046-.083.102-.16.169-.226l5-5a1 1 0 1 1 1.414 1.414L6.414 14H13.5c1.545 0 2.598-.436 3.34-1.035.756-.611 1.262-1.453 1.596-2.37C19.113 8.734 19 6.805 19 6.5V4a1 1 0 0 1 1-1Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgCornerDownLeft)
